import { Button} from "@mui/material";

import { useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { useEffect } from "react";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytes,
} from "firebase/storage";
import { showCustomToast } from "../Misc/CustomToast";
import { useAuth } from "../../contexts/AuthContext";
import PersonalInformation from "../GeneralInformationComponents/PersonalInformation";
import TreatmentInformation from "../GeneralInformationComponents/TreatmentInformation";
import AdmissionDischarge from "../GeneralInformationComponents/AdmissionDischarge";
import EmergencyContact from "../GeneralInformationComponents/EmergencyContact";
import LineLogs from "../Lines/LineLogs";
import UploaderGeneralInfosEncapsulatedBis from "../Updloader/UploaderGeneralInfosEncapsulatedBis";
import StandardDrawer, { StandardDrawerFooter, StandardDrawerHeader } from "../forms/StandardDrawer";
import "../PreAdmission.css";
import { writeBatch } from "firebase/firestore";
import rehabs, { getRehabByClient } from "../../api/rehabs";

function GeneralInformation(props) {
  const [logs, setLogs] = useState([]);
  const [isModalLogsOpen, setIsModalLogsOpen] = useState(false);
  const [, setIsLoadingFetchLogs] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const closeDetailLogsModal = () => setIsDetailsModalOpen(false);
  const closeLogsModal = () => setIsModalLogsOpen(false);
  // Ajoutez cet état au début du composant GeneralInformation avec les autres états
  const [profilePicture] = useState(
    props.profilePicture || ""
  );


  const showLogDetails = (selectedLog) => {
    const changes = selectedLog.changes;
    const who = selectedLog.recordedBy;
    const when = formatDateLogs(selectedLog.recordedAt);

    return (
      <div className="pre-admission-detail-content">
        <div className="pre-admission-detail-summary">
          <span>Recorded by</span>
          <strong>{who}</strong>
          <time>{when}</time>
        </div>
        <div className="pre-admission-change-list">
          {Object.entries(changes)
            .filter(([key]) => key !== "lastModification")
            .map(([key, value]) => (
              <article className="pre-admission-change-card" key={key}>
                <div className="pre-admission-change-field">{key}</div>
                <div className="pre-admission-change-label">New value</div>
                <div className="pre-admission-change-value">
                  {typeof value === "string" ? value : JSON.stringify(value, null, 2)}
                </div>
              </article>
            ))}
        </div>
      </div>
    );
  };

  function formatDate3(value) {
    // Assurez-vous que la valeur est une instance de Timestamp
    // et convertissez-la en objet Date, puis formatez-la.
    if (value && value.toDate) {
      return value.toDate().toLocaleString("en-EN", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    }
    return value;
  }

  const handleShowDetailsClick = (selectedLog) => {
    const sortedLogs = logs.sort(
      (a, b) => b.recordedAt.toDate() - a.recordedAt.toDate()
    );

    const selectedIndex = sortedLogs.findIndex(
      (log) => log.id === selectedLog.id
    );

    if (selectedIndex === -1) {
      setSelectedLog({ ...selectedLog, changes: selectedLog.changes });
    } else {
      const previousLog = sortedLogs[selectedIndex + 1];

      let differences = {};
      Object.keys(selectedLog.changes).forEach((key) => {
        let currentValue = selectedLog.changes[key];
        const previousValue = previousLog
          ? previousLog.changes[key]
          : undefined;

        // Appliquer le formatage si la valeur est un timestamp
        currentValue = formatDate3(currentValue);

        // Vérifiez que la valeur actuelle n'est pas vide avant de l'ajouter
        if (
          (!previousLog ||
            JSON.stringify(currentValue) !== JSON.stringify(previousValue)) &&
          currentValue !== undefined &&
          currentValue !== null &&
          currentValue !== ""
        ) {
          differences[key] = currentValue;
        }
      });

      setSelectedLog({ ...selectedLog, changes: differences });
    }

    setIsDetailsModalOpen(true);
  };

  const fetchLogs = async (clientId) => {
    setIsLoadingFetchLogs(true);
    try {
      const querySnapshot = await getDocs(
        collection(db, "logs-general-infos", clientId, "modifications")
      );
      const fetchedLogs = [];
      querySnapshot.forEach((doc) => {
        fetchedLogs.push({ id: doc.id, ...doc.data() });
      });
      setLogs(fetchedLogs);
    } catch (error) {
      console.error("Error fetching logs: ", error);
    } finally {
      setIsLoadingFetchLogs(false);
    }
  };

  const openModalLogs = (clientId) => {
    fetchLogs(clientId);
    setIsModalLogsOpen(true);
  };

  const formatDateLogs = (timestamp) => {
    const date = timestamp.toDate();
    return date.toLocaleString(); // Formate la date selon la locale de l'environnement
  };

  // useEffect(() => {}, [props.clientId]);

  //VARIABLES
  const maxSizePicFile = 2 * 1024 * 1024;

  //STATE
  const [isModified, setIsModified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTherapist, setSelectedTherapist] = useState(
    props.selectedTherapist || ""
  );

  const [assignedSupportWorker, setAssignedSupportWorker] = useState(
    props.assignedSupportWorker || ""
  );
  const [genderOther, setGenderOther] = useState(props.genderOther || "");
  const [sexualOrientationOther, setSexualOrientationOther] = useState(
    props.sexualOrientationOther || ""
  );
  const [livingWithOther, setLivingWithOther] = useState(
    props.livingWithOther || ""
  );
  const [province, setProvince] = useState(props.province || "");
  const [provinceEmergencyContact, setProvinceEmergencyContact] = useState(
    props.provinceEmergencyContact || ""
  );
  const [emergencyRelationshipOther, setEmergencyRelationshipOther] = useState(
    props.emergencyRelationshipOther || ""
  );
  const [clientIdState, setClientIdState] = useState(props.clientId || "");
  const [firstName, setFirstName] = useState(props.firstName || "");
  const [lastName, setLastName] = useState(props.lastName || "");
  const [nickname, setNickname] = useState(props.nickname || "");
  const [clientSource, setClientSource] = useState(props.clientSource || "");
  const [gender, setGender] = useState(props.gender || "");
  const [sexualOrientation, setSexualOrientation] = useState(
    props.sexualOrientation || ""
  );
  const [personalEmail, setPersonalEmail] = useState(props.personalEmail || "");
  const [phoneNumber, setPhoneNumber] = useState(props.phoneNumber || "");
  const [dob, setDob] = useState(props.dob || "");
  const [currentAddress, setCurrentAddress] = useState(
    props.currentAddress || ""
  );
  const [city, setCity] = useState(props.city || "");
  const [nationality, setNationality] = useState(props.nationality || "");
  const [country, setCountry] = useState(props.country || "");
  const [rehabId, setRehabId] = useState(getRehabByClient(props)?.id || "");
  const [durationOfStay, setDurationOfStay] = useState(
    props.durationOfStay || ""
  );
  const [dateOfAdmission, setDateOfAdmission] = useState(
    props.dateOfAdmission || ""
  );
  const [
    projectedResidentialDischargeDate,
    setProjectedResidentialDischargeDate,
  ] = useState(props.projectedResidentialDischargeDate || "");
  const [maritalStatus, setMaritalStatus] = useState(props.maritalStatus || "");
  const [livingWith, setLivingWith] = useState(props.livingWith || "");
  const [projectedProgramCompletionDate, setProjectedProgramCompletionDate] =
    useState(props.projectedProgramCompletionDate || "");
  const [passportNumber, setPassportNumber] = useState(
    props.passportNumber || ""
  );
  const [roomNumber, setRoomNumber] = useState(props.roomNumber || "");
  const [visaExpirationDate, setVisaExpirationDate] = useState(
    props.visaExpirationDate || ""
  );

  const [dischargeDate, setDischargeDate] = useState(
    props.actualDischargeDate || null
  );
  const [emergencyContactFirstName, setEmergencyContactFirstName] = useState(
    props.emergencyContactFirstName || ""
  );
  const [emergencyContactLastName, setEmergencyContactLastName] = useState(
    props.emergencyContactLastName || ""
  );
  const [emergencyContactRelationship, setEmergencyContactRelationship] =
    useState(props.emergencyContactRelationship || "");
  const [emergencyContactPhoneNumber, setEmergencyContactPhoneNumber] =
    useState(props.emergencyContactPhoneNumber || "");
  const [emergencyContactEmail, setEmergencyContactEmail] = useState(
    props.emergencyContactEmail || ""
  );
  const [emergencyContactAddress, setEmergencyContactAddress] = useState(
    props.emergencyContactAddress || ""
  );
  const [emergencyContactCity, setEmergencyContactCity] = useState(
    props.emergencyContactCity || ""
  );
  const [emergencyContactNationality, setEmergencyContactNationality] =
    useState(props.emergencyContactNationality || "");
  const [emergencyContactCountry, setEmergencyContactCountry] = useState(
    props.emergencyContactCountry || ""
  );
  const [payerName, setPayerName] = useState(props.payerName || "");
  const [payerPhoneNumber, setPayerPhoneNumber] = useState(
    props.payerPhoneNumber || ""
  );
  const [inTakestaffName, setInTakestaffName] = useState(
    props.inTakestaffName || ""
  );
  const [intakeStaffId, setIntakeStaffId] = useState(props.intakeStaffId || "");
  const [intakeStaffEmail, setIntakeStaffEmail] = useState(
    props.intakeStaffEmail || ""
  );
  const [clientStatus, setClientStatus] = useState(props.clientStatus || "");
  const [age, setAge] = useState("NA");
  const [, setLastModification] = useState(
    props.lastModification || ""
  );
  const [files] = useState([]);
  const [, setFileLinks] = useState(props.fileUrls || []);
  const [acknowledgmentOfPresence, setAcknowledgmentOfPresence] = useState(
    props.emergencyCheckbox0 || false
  );
  const [clinicalInformation, setClinicalInformation] = useState(
    props.emergencyCheckbox1 || false
  );
  const [psychEvaluation, setPsychEvaluation] = useState(
    props.emergencyCheckbox2 || false
  );
  const [referralLetter, setReferralLetter] = useState(
    props.emergencyCheckbox3 || false
  );
  const [labData, setLabData] = useState(props.emergencyCheckbox4 || false);
  const [progressNotes, setProgressNotes] = useState(
    props.emergencyCheckbox5 || false
  );
  const [medicalRecords, setMedicalRecords] = useState(
    props.emergencyCheckbox6 || false
  );
  const [progressInTreatment, setProgressInTreatment] = useState(
    props.emergencyCheckbox7 || false
  );
  const [psychosocialAssessment, setPsychosocialAssessment] = useState(
    props.emergencyCheckbox8 || false
  );
  const [medicationInfo, setMedicationInfo] = useState(
    props.emergencyCheckbox9 || false
  );
  const [treatmentPlan, setTreatmentPlan] = useState(
    props.emergencyCheckbox10 || false
  );
  const [physicalAssessment, setPhysicalAssessment] = useState(
    props.emergencyCheckbox11 || false
  );
  const [dischargeSummary, setDischargeSummary] = useState(
    props.emergencyCheckbox12 || false
  );
  const [familyHistory, setFamilyHistory] = useState(
    props.emergencyCheckbox13 || false
  );
  const [dischargePlan, setDischargePlan] = useState(
    props.emergencyCheckbox14 || false
  );
  const [admissionDischargeDates, setAdmissionDischargeDates] = useState(
    props.emergencyCheckbox15 || false
  );
  const [otherInfo, setOtherInfo] = useState(
    props.emergencyCheckboxContent15 || ""
  );
  const [otherInfoInput, setOtherInfoInput] = useState(
    props.emergencyCheckboxContent15Input || ""
  );

  // Ajoutez ces useState avec vos autres états
  const [therapistAppointment, setTherapistAppointment] = useState(
    props.therapistAppointment || ""
  );
  const [supportWorkerAppointment, setSupportWorkerAppointment] = useState(
    props.supportWorkerAppointment || ""
  );
  const [medicalAppointment, setMedicalAppointment] = useState(
    props.medicalAppointment || ""
  );
  const [visaAppointment, setVisaAppointment] = useState(
    props.visaAppointment || ""
  );
  const [stepsAppointment, setStepsAppointment] = useState(
    props.stepsAppointment || ""
  );
  const [massageDay, setMassageDay] = useState(props.massageDay || "");
  const [therapistAppointmentDays, setTherapistAppointmentDays] = useState(
    props.therapistAppointmentDays || ""
  );
  const [therapistAppointmentTime, setTherapistAppointmentTime] = useState(
    props.therapistAppointmentTime || ""
  );

  // pour Support Worker Appt
  const [supportWorkerAppointmentDays, setSupportWorkerAppointmentDays] =
    useState(props.supportWorkerAppointmentDays || "");
  const [supportWorkerAppointmentTime, setSupportWorkerAppointmentTime] =
    useState(props.supportWorkerAppointmentTime || "");
  // pour 12 Steps Appt
  const [stepsAppointmentDays, setStepsAppointmentDays] = useState(
    props.stepsAppointmentDays || ""
  );
  const [stepsAppointmentTime, setStepsAppointmentTime] = useState(
    props.stepsAppointmentTime || ""
  );

  // handlers
  const handleSupportWorkerAppointmentDaysChange = (v) => {
    setSupportWorkerAppointmentDays(v);
    setIsModified(true);
  };
  const handleSupportWorkerAppointmentTimeChange = (v) => {
    setSupportWorkerAppointmentTime(v);
    setIsModified(true);
  };
  const handleStepsAppointmentDaysChange = (v) => {
    setStepsAppointmentDays(v);
    setIsModified(true);
  };
  const handleStepsAppointmentTimeChange = (v) => {
    setStepsAppointmentTime(v);
    setIsModified(true);
  };

  const handleTherapistAppointmentDaysChange = (value) => {
    setTherapistAppointmentDays(value);
    setIsModified(true);
  };
  const handleTherapistAppointmentTimeChange = (value) => {
    setTherapistAppointmentTime(value);
    setIsModified(true);
  };
  // FUNCTIONS

  const handleProvinceChange = (event) => {
    setProvince(event);
    setIsModified(true);
  };

  const handleProvinceEmergencyContactChange = (event) => {
    setIsModified(true);
    setProvinceEmergencyContact(event);
  };

  const handleGenderOther = (event) => {
    setIsModified(true);
    setGenderOther(event);
  };

  const handleSexualOrientationOther = (event) => {
    setIsModified(true);
    setSexualOrientationOther(event);
  };

  const handleEmergencyRelationshipOther = (event) => {
    setIsModified(true);
    setEmergencyRelationshipOther(event);
  };

  const handleLivingWithOther = (event) => {
    setIsModified(true);
    setLivingWithOther(event);
  };

  const handleMaritalStatusChange = (event) => {
    setIsModified(true);
    setMaritalStatus(event);
  };

  const handleLivingWithChange = (event) => {
    setIsModified(true);
    setLivingWith(event);
  };

  const handleSelectedTherapistChange = (value) => {
    setIsModified(true);
    setSelectedTherapist(value);
  };

  const handleAssignedSupportWorkerChange = (value) => {
    setIsModified(true);
    setAssignedSupportWorker(value);
  };

  const handleFirstNameChange = (event) => {
    setIsModified(true);
    setFirstName(event);
  };

  const handleLastNameChange = (event) => {
    setIsModified(true);
    setLastName(event);
  };

  const handleNicknameChange = (event) => {
    setIsModified(true);
    setNickname(event);
  };

  const handleGenderChange = (value) => {
    setIsModified(true);
    setGender(value);
  };

  const handleSexualOrientationChange = (value) => {
    setIsModified(true);
    setSexualOrientation(value);
  };

  const handlePersonalEmailChange = (event) => {
    setIsModified(true);
    setPersonalEmail(event);
  };

  const handlePhoneNumberChange = (value) => {
    setIsModified(true);
    setPhoneNumber(value);
  };

  const handleDobChange = (value) => {
    setIsModified(true);
    setDob(value);
    setAge(getAge(value));
  };

  const handleCurrentAddressChange = (event) => {
    setIsModified(true);
    setCurrentAddress(event);
  };

  const handleCityChange = (event) => {
    setIsModified(true);
    setCity(event);
  };

  const handleNationalityChange = (value) => {
    setIsModified(true);
    setNationality(value);
  };

  const handleCountryChange = (value) => {
    setIsModified(true);
    setCountry(value);
  };

  const handleRehabChange = (event) => {
    setRehabId(event.target.value);
    setIsModified(true);
  };

  const handleDateOfAdmissionChange = (value) => {
    setIsModified(true);
    setDateOfAdmission(value);
  };

  const handleProjectedResidentialDischargeDateChange = (value) => {
    setIsModified(true);
    setProjectedResidentialDischargeDate(value);
  };

  const handleProjectedProgramCompletionDateChange = (value) => {
    setIsModified(true);
    setProjectedProgramCompletionDate(value);
  };

  const handleDischargeDateChange = (value) => {
    setIsModified(true);
    setDischargeDate(value);
  };

  const handlePassportNumberChange = (event) => {
    setIsModified(true);
    setPassportNumber(event);
  };

  const handleMedicalAppointmentChange = (value) => {
    setMedicalAppointment(value);
    setIsModified(true);
  };

  const handleVisaAppointmentChange = (value) => {
    setVisaAppointment(value);
    setIsModified(true);
  };

  const handleMassageDayChange = (value) => {
    setMassageDay(value);
    setIsModified(true);
  };

  const moveToRoom = async ({ newRoom, oldRoom, status }) => {
    const batch = writeBatch(db);

    // Ne rien faire si identique
    if (newRoom === oldRoom) return;

    // Libérer l’ancienne
    if (oldRoom) {
      batch.delete(doc(db, "RoomNumbers", oldRoom));
    }

    // Occuper la nouvelle uniquement si In House
    if (status === "In House" && newRoom) {
      batch.set(doc(db, "RoomNumbers", newRoom), {
        occupied: true,
        clientId: props.clientId, // <-- utilise la prop directement
        clientFirstName: firstName,
        clientLastName: lastName,
        profilePictureUrl: profilePicture,
      });
    }

    await batch.commit();
  };

  useEffect(() => {
    // Si le client sort, on libère la chambre et on vide le champ côté client
    if (clientStatus && clientStatus !== "In House" && roomNumber) {
      (async () => {
        await moveToRoom({
          newRoom: "",
          oldRoom: roomNumber,
          status: clientStatus,
        });
        await updateDoc(doc(db, "clients", props.clientId), { roomNumber: "" });
        setRoomNumber("");
      })();
    }
  }, [clientStatus]);

  const handleRoomNumberChange = async (value) => {
    await moveToRoom({
      newRoom: value,
      oldRoom: roomNumber,
      status: clientStatus, // même logique partout
    });

    await updateDoc(doc(db, "clients", props.clientId), { roomNumber: value });

    setRoomNumber(value);
    setIsModified(true);
  };

  const handleVisaExpirationDateChange = (value) => {
    setIsModified(true);
    setVisaExpirationDate(value);
  };

  const handleEmergencyContactFirstNameChange = (event) => {
    setIsModified(true);
    setEmergencyContactFirstName(event);
  };

  const handleEmergencyContactLastNameChange = (event) => {
    setIsModified(true);
    setEmergencyContactLastName(event);
  };

  const handleEmergencyContactRelationshipChange = (value) => {
    setIsModified(true);
    setEmergencyContactRelationship(value);
  };

  const handleEmergencyContactPhoneNumberChange = (value) => {
    setIsModified(true);
    setEmergencyContactPhoneNumber(value);
  };

  const handleEmergencyContactEmailChange = (event) => {
    setIsModified(true);
    setEmergencyContactEmail(event);
  };

  const handleEmergencyContactAddressChange = (event) => {
    setIsModified(true);
    setEmergencyContactAddress(event);
  };

  const handleEmergencyContactCityChange = (event) => {
    setIsModified(true);
    setEmergencyContactCity(event);
  };

  const handleEmergencyContactNationalityChange = (value) => {
    setIsModified(true);
    setEmergencyContactNationality(value);
  };

  const handleEmergencyContactCountryChange = (value) => {
    setIsModified(true);
    setEmergencyContactCountry(value);
  };

  const handlePayerNameChange = (event) => {
    setIsModified(true);
    setPayerName(event);
  };

  const handlePayerPhoneNumberChange = (value) => {
    setIsModified(true);
    setPayerPhoneNumber(value);
  };

  const handleClientSourceChange = (value) => {
    setIsModified(true);
    setClientSource(value);
  };


  function getAge(dobTimestamp) {
    if (!dobTimestamp) {
      return "NA";
    }

    const dob = dobTimestamp.toDate(); // Convertit le timestamp Firestore en une date JavaScript
    const diff = Date.now() - dob.getTime();
    const ageDate = new Date(diff);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  useEffect(() => {
    setAge(getAge(dob));
  }, [dob]);

  const uploadFilesAndGetUrls = async (docId) => {
    const storage = getStorage();
    const fileUrls = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file.size > maxSizePicFile) {
        showCustomToast(`File size exceeds the limit: ${file.name}`, "error");

        console.error(`File size exceeds the limit: ${file.name}`);
        continue; // Passez au fichier suivant dans la boucle
      }
      const filePath = `Documents/generalInfos/${docId}/${file.name}`;
      const storageRef = ref(storage, filePath);

      await uploadBytes(storageRef, file);
      const fileUrl = await getDownloadURL(storageRef);
      fileUrls.push({ url: fileUrl, name: file.name });
    }

    return fileUrls;
  };


  useEffect(() => {}, [files]);

  const updateClientData = async (clientId) => {
    if (firstName && lastName) {
      setIsLoading(true);
      try {
        const clientRef = doc(db, "clients", clientId);
        const fileUrls = await uploadFilesAndGetUrls(clientRef.id);
        const clientDoc = await getDoc(clientRef);
        const existingFileUrls = clientDoc.data().fileUrls || [];
        const mergedFileUrls = [...existingFileUrls, ...fileUrls];
        const selectedRehab =
          rehabs.find((rehab) => rehab.id === rehabId) || getRehabByClient(props);

        await updateDoc(clientRef, {
          selectedTherapist,
          firstName,
          lastName,
          nickname,
          gender,
          sexualOrientation,
          personalEmail,
          phoneNumber,
          dob,
          currentAddress,
          city,
          nationality,
          country,
          rehabId: selectedRehab.id,
          rehabName: selectedRehab.name,
          rehabCountry: selectedRehab.country,
          rehabLocation: selectedRehab.location,
          rehabTimezone: selectedRehab.timezone,
          rehabCurrency: selectedRehab.currency,
          durationOfStay,
          dateOfAdmission,
          projectedResidentialDischargeDate,
          maritalStatus,
          livingWith,
          projectedProgramCompletionDate,
          passportNumber,
          roomNumber,
          visaExpirationDate,
          emergencyContactFirstName,
          emergencyContactLastName,
          emergencyContactRelationship,
          emergencyContactPhoneNumber,
          emergencyContactEmail,
          emergencyContactAddress,
          emergencyContactCity,
          emergencyContactNationality,
          emergencyContactCountry,
          emergencyRelationshipOther,
          payerName,
          payerPhoneNumber,
          inTakestaffName,
          intakeStaffId,
          intakeStaffEmail,
          clientStatus,
          age,
          lastModification: serverTimestamp(),
          lastModificationDoneBy: currentUser.displayName,
          fileUrls: mergedFileUrls,
          genderOther,
          sexualOrientationOther,
          livingWithOther,
          province,
          provinceEmergencyContact,
          emergencyCheckbox0: acknowledgmentOfPresence,
          emergencyCheckbox1: clinicalInformation,
          emergencyCheckbox2: psychEvaluation,
          emergencyCheckbox3: referralLetter,
          emergencyCheckbox4: labData,
          emergencyCheckbox5: progressNotes,
          emergencyCheckbox6: medicalRecords,
          emergencyCheckbox7: progressInTreatment,
          emergencyCheckbox8: psychosocialAssessment,
          emergencyCheckbox9: medicationInfo,
          emergencyCheckbox10: treatmentPlan,
          emergencyCheckbox11: physicalAssessment,
          emergencyCheckbox12: dischargeSummary,
          emergencyCheckbox13: familyHistory,
          emergencyCheckbox14: dischargePlan,
          emergencyCheckbox15: admissionDischargeDates,
          emergencyCheckboxContent15: otherInfo,
          emergencyCheckboxContent15Input: otherInfoInput,
          actualDischargeDate: dischargeDate,
          assignedSupportWorker: assignedSupportWorker,
          clientSource: clientSource,
          // Ajoutez ces propriétés dans l'objet à sauvegarder :
          therapistAppointment,
          therapistAppointmentDays,
          therapistAppointmentTime,
          supportWorkerAppointment,
          medicalAppointment,
          visaAppointment,
          stepsAppointment,
          massageDay,
          supportWorkerAppointmentDays,
          supportWorkerAppointmentTime,
          stepsAppointmentDays,
          stepsAppointmentTime,
        });
        setIsModified(false);
        setIsLoading(false);

        const newData = {
          selectedTherapist,
          firstName,
          lastName,
          nickname,
          gender,
          sexualOrientation,
          personalEmail,
          phoneNumber,
          dob,
          currentAddress,
          city,
          nationality,
          country,
          rehabId: selectedRehab.id,
          rehabName: selectedRehab.name,
          rehabCountry: selectedRehab.country,
          rehabLocation: selectedRehab.location,
          rehabTimezone: selectedRehab.timezone,
          rehabCurrency: selectedRehab.currency,
          durationOfStay,
          dateOfAdmission,
          projectedResidentialDischargeDate,
          maritalStatus,
          livingWith,
          projectedProgramCompletionDate,
          passportNumber,
          roomNumber,
          visaExpirationDate,
          emergencyContactFirstName,
          emergencyContactLastName,
          emergencyContactRelationship,
          emergencyContactPhoneNumber,
          emergencyContactEmail,
          emergencyContactAddress,
          emergencyContactCity,
          emergencyContactNationality,
          emergencyContactCountry,
          emergencyRelationshipOther,
          payerName,
          payerPhoneNumber,
          inTakestaffName,
          intakeStaffId,
          intakeStaffEmail,
          clientStatus,
          age,
          lastModification: serverTimestamp(),
          lastModificationDoneBy: currentUser.displayName,
          fileUrls: mergedFileUrls,
          genderOther,
          sexualOrientationOther,
          livingWithOther,
          province,
          provinceEmergencyContact,
          emergencyCheckbox0: acknowledgmentOfPresence,
          emergencyCheckbox1: clinicalInformation,
          emergencyCheckbox2: psychEvaluation,
          emergencyCheckbox3: referralLetter,
          emergencyCheckbox4: labData,
          emergencyCheckbox5: progressNotes,
          emergencyCheckbox6: medicalRecords,
          emergencyCheckbox7: progressInTreatment,
          emergencyCheckbox8: psychosocialAssessment,
          emergencyCheckbox9: medicationInfo,
          emergencyCheckbox10: treatmentPlan,
          emergencyCheckbox11: physicalAssessment,
          emergencyCheckbox12: dischargeSummary,
          emergencyCheckbox13: familyHistory,
          emergencyCheckbox14: dischargePlan,
          emergencyCheckbox15: admissionDischargeDates,
          emergencyCheckboxContent15: otherInfo,
          emergencyCheckboxContent15Input: otherInfoInput,
          actualDischargeDate: dischargeDate,
          assignedSupportWorker: assignedSupportWorker,
          clientSource: clientSource,
          therapistAppointmentDays,
          therapistAppointmentTime,
        };

        const clientLogsRef = doc(
          collection(db, "logs-general-infos", clientId, "modifications")
        );

        const logEntry = {
          clientId,
          changes: newData, // ou une sélection spécifique de newData si tout n'est pas pertinent
          recordedBy: currentUser?.displayName,
          recordedAt: serverTimestamp(),
        };
        await setDoc(clientLogsRef, logEntry);

        showCustomToast("Client successfully updated!", "success");
      } catch (error) {
        console.error("Error updating client: ", error);
        setIsLoading(false);
        showCustomToast(`Error updating client: ${error}`, "error");
      }
    } else {
      showCustomToast(
        "Some mandatory fields are empty. Please check.",
        "error"
      );
    }
  };

  useEffect(() => {
    setSupportWorkerAppointmentDays(props.supportWorkerAppointmentDays || "");
    setSupportWorkerAppointmentTime(props.supportWorkerAppointmentTime || "");
    setStepsAppointmentDays(props.stepsAppointmentDays || "");
    setStepsAppointmentTime(props.stepsAppointmentTime || "");

    setSelectedTherapist(props.selectedTherapist || "");
    setFirstName(props.firstName || "");
    setLastName(props.lastName || "");
    setNickname(props.nickname || "");
    setGender(props.gender || "");
    setSexualOrientation(props.sexualOrientation || "");
    setPersonalEmail(props.personalEmail || "");
    setPhoneNumber(props.phoneNumber || "");
    setDob(props.dob || "");
    setCurrentAddress(props.currentAddress || "");
    setCity(props.city || "");
    setNationality(props.nationality || "");
    setCountry(props.country || "");
    setRehabId(getRehabByClient(props)?.id || "");
    setDurationOfStay(props.durationOfStay || "");
    setDateOfAdmission(props.dateOfAdmission || "");
    setProjectedResidentialDischargeDate(
      props.projectedResidentialDischargeDate || ""
    );
    setMaritalStatus(props.maritalStatus || "");
    setLivingWith(props.livingWith || "");
    setProjectedProgramCompletionDate(
      props.projectedProgramCompletionDate || ""
    );
    setPassportNumber(props.passportNumber || "");
    setRoomNumber(props.roomNumber || "");
    setVisaExpirationDate(props.visaExpirationDate || "");
    setEmergencyContactFirstName(props.emergencyContactFirstName || "");
    setEmergencyContactLastName(props.emergencyContactLastName || "");
    setEmergencyContactRelationship(props.emergencyContactRelationship || "");
    setEmergencyContactPhoneNumber(props.emergencyContactPhoneNumber || "");
    setEmergencyContactEmail(props.emergencyContactEmail || "");
    setEmergencyContactAddress(props.emergencyContactAddress || "");
    setEmergencyContactCity(props.emergencyContactCity || "");
    setEmergencyContactNationality(props.emergencyContactNationality || "");
    setEmergencyContactCountry(props.emergencyContactCountry || "");
    setPayerName(props.payerName || "");
    setPayerPhoneNumber(props.payerPhoneNumber || "");
    setInTakestaffName(props.inTakestaffName || "");
    setIntakeStaffId(props.intakeStaffId || "");
    setIntakeStaffEmail(props.intakeStaffEmail || "");
    setClientStatus(props.clientStatus || "");
    // setAge(props.age || "");
    setLastModification(props.lastModification || "");
    setFileLinks(props.fileUrls || "");
    setGenderOther(props.genderOther || "");
    setSexualOrientationOther(props.sexualOrientationOther || "");
    setLivingWithOther(props.livingWithOther || "");
    setEmergencyRelationshipOther(props.emergencyRelationshipOther || "");
    setProvince(props.province || "");
    setProvinceEmergencyContact(props.provinceEmergencyContact || "");
    setAcknowledgmentOfPresence(props.emergencyCheckbox0 || false);
    setClinicalInformation(props.emergencyCheckbox1 || false);
    setPsychEvaluation(props.emergencyCheckbox2 || false);
    setReferralLetter(props.emergencyCheckbox3 || false);
    setLabData(props.emergencyCheckbox4 || false);
    setProgressNotes(props.emergencyCheckbox5 || false);
    setMedicalRecords(props.emergencyCheckbox6 || false);
    setProgressInTreatment(props.emergencyCheckbox7 || false);
    setPsychosocialAssessment(props.emergencyCheckbox8 || false);
    setMedicationInfo(props.emergencyCheckbox9 || false);
    setTreatmentPlan(props.emergencyCheckbox10 || false);
    setPhysicalAssessment(props.emergencyCheckbox11 || false);
    setDischargeSummary(props.emergencyCheckbox12 || false);
    setFamilyHistory(props.emergencyCheckbox13 || false);
    setDischargePlan(props.emergencyCheckbox14 || false);
    setAdmissionDischargeDates(props.emergencyCheckbox15 || false);
    setOtherInfo(props.emergencyCheckboxContent15 || "");
    setOtherInfoInput(props.emergencyCheckboxContent15Input || "");
    setDischargeDate(props.actualDischargeDate || null);
    setAssignedSupportWorker(props.assignedSupportWorker || "");
    setClientSource(props.clientSource || "");
    setTherapistAppointment(props.therapistAppointment || "");
    setSupportWorkerAppointment(props.supportWorkerAppointment || "");
    setMedicalAppointment(props.medicalAppointment || "");
    setVisaAppointment(props.visaAppointment || "");
    setStepsAppointment(props.stepsAppointment || "");
    setMassageDay(props.massageDay || "");
    setTherapistAppointmentDays(props.therapistAppointmentDays || "");
    setTherapistAppointmentTime(props.therapistAppointmentTime || "");
  }, [
    props.supportWorkerAppointmentDays,
    props.supportWorkerAppointmentTime,
    props.stepsAppointmentDays,
    props.stepsAppointmentTime,

    props.actualDischargeDate,
    props.selectedTherapist,
    props.firstName,
    props.lastName,
    props.nickname,
    props.gender,
    props.sexualOrientation,
    props.personalEmail,
    props.phoneNumber,
    props.dob,
    props.currentAddress,
    props.city,
    props.nationality,
    props.country,
    props.rehabId,
    props.rehabCountry,
    props.durationOfStay,
    props.dateOfAdmission,
    props.projectedResidentialDischargeDate,
    props.maritalStatus,
    props.livingWith,
    props.projectedProgramCompletionDate,
    props.passportNumber,
    props.roomNumber,
    props.visaExpirationDate,
    props.emergencyContactFirstName,
    props.emergencyContactLastName,
    props.emergencyContactRelationship,
    props.emergencyContactPhoneNumber,
    props.emergencyContactEmail,
    props.emergencyContactAddress,
    props.emergencyContactCity,
    props.emergencyContactNationality,
    props.emergencyContactCountry,
    props.emergencyRelationshipOther,
    props.payerName,
    props.payerPhoneNumber,
    props.inTakestaffName,
    props.intakeStaffId,
    props.intakeStaffEmail,
    props.clientStatus,
    props.age,
    props.lastModification,
    props.fileUrls,
    props.genderOther,
    props.sexualOrientationOther,
    props.livingWithOther,
    props.province,
    props.provinceEmergencyContact,
    props.emergencyCheckbox0,
    props.emergencyCheckbox1,
    props.emergencyCheckbox2,
    props.emergencyCheckbox3,
    props.emergencyCheckbox4,
    props.emergencyCheckbox5,
    props.emergencyCheckbox6,
    props.emergencyCheckbox7,
    props.emergencyCheckbox8,
    props.emergencyCheckbox9,
    props.emergencyCheckbox10,
    props.emergencyCheckbox11,
    props.emergencyCheckbox12,
    props.emergencyCheckbox13,
    props.emergencyCheckbox14,
    props.emergencyCheckbox15,
    props.emergencyCheckboxContent15,
    props.emergencyCheckboxContent15Input,
    props.assignedSupportWorker,
    props.clientSource,
    props.therapistAppointment,
    props.supportWorkerAppointment,
    props.medicalAppointment,
    props.visaAppointment,
    props.stepsAppointment,
    props.massageDay,
    props.therapistAppointmentDays,
    props.therapistAppointmentTime,
  ]);

  const { currentUser } = useAuth();

  useEffect(() => {
    props.onModificationChange(isModified);
  }, [isModified]);


  useEffect(() => {
    setClientIdState(props.clientId || "");
  }, [props.clientId]);

  // À placer avant votre composant
  const generateTimeOptions = () => {
    const opts = [];
    for (let h = 6; h <= 22; h++) {
      // for (let m of [0, 30]) {
      for (let m of [0, 15, 30, 45]) {
        const date = new Date();
        date.setHours(h, m);
        const label = date.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
        });
        const value = `${String(h).padStart(2, "0")}:${String(m).padStart(
          2,
          "0"
        )}`;
        opts.push({ value, label });
      }
    }
    return opts;
  };

  return (
    <div className="tab-container-white-desktop">
      <div className="container-main-plan-mobile-2">
        <div className="tab-container-title-mobile-3 ">
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: "10px",
                paddingLeft: "10px",
              }}
            >
              {/* PRE ADMISSION{" "} */}
              <button
                type="button"
                className="pre-admission-activity-button"
                style={{
                  marginLeft: "0px",
                }}
                onClick={() => openModalLogs(props.clientId)}
              >
                <span className="pre-admission-activity-icon">↻</span>
                Activity Logs
                <span className="pre-admission-activity-count">{logs.length}</span>
              </button>
            </div>
            <span
              style={{
                fontSize: "12px",
                fontStyle: "italic",
                paddingLeft: "5px",
              }}
            >
              {props.creatorName && props.dateOfCreation && (
                <div style={{ fontSize: "12px", fontStyle: "italic" }}>
                  {`Client added by ${
                    props.creatorName
                  } on ${props.dateOfCreation.toDate().toLocaleString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                  })}`}
                </div>
              )}
            </span>
          </div>

          {isDetailsModalOpen && (
            <StandardDrawer
              open={isDetailsModalOpen}
              onClose={() => setIsDetailsModalOpen(false)}
              SlideProps={{ direction: "left" }}
            >
              <div className="standard-drawer-form-wrapper">
                <StandardDrawerHeader eyebrow="GENERAL INFORMATION" title="Activity log details" subtitle="Change history" onClose={closeDetailLogsModal} />
                {selectedLog &&
                  showLogDetails(selectedLog, closeDetailLogsModal)}
                <StandardDrawerFooter><Button variant="contained" onClick={closeDetailLogsModal}>Close</Button></StandardDrawerFooter>
              </div>
            </StandardDrawer>
          )}
          {isModalLogsOpen && (
            <StandardDrawer
              open={isModalLogsOpen}
              onClose={() => setIsModalLogsOpen(false)}
              SlideProps={{ direction: "left" }}
            >
              <div className="standard-drawer-form-wrapper">
                <StandardDrawerHeader eyebrow="GENERAL INFORMATION" title="Activity logs" subtitle={`${logs.length} recorded changes`} onClose={closeLogsModal} />
                <div className="pre-admission-activity-body">
                  {logs
                    .sort(
                      (a, b) => b.recordedAt.toDate() - a.recordedAt.toDate()
                    )
                    .map((log) => (
                      <LineLogs
                        key={log.id}
                        log={log}
                        onDetailsClick={() => handleShowDetailsClick(log)}
                      />
                    ))}
                </div>
                <StandardDrawerFooter><Button variant="contained" onClick={closeLogsModal}>Close</Button></StandardDrawerFooter>
              </div>
            </StandardDrawer>
          )}
        </div>

        <div className="general-information-panels">
          <PersonalInformation
            firstName={firstName}
            handleFirstNameChange={handleFirstNameChange}
            lastName={lastName}
            handleLastNameChange={handleLastNameChange}
            nickname={nickname}
            handleNicknameChange={handleNicknameChange}
            dob={dob}
            handleDobChange={handleDobChange}
            age={age}
            maritalStatus={maritalStatus}
            handleMaritalStatusChange={handleMaritalStatusChange}
            livingWith={livingWith}
            handleLivingWithChange={handleLivingWithChange}
            gender={gender}
            handleGenderChange={handleGenderChange}
            genderOther={genderOther}
            handleGenderOther={handleGenderOther}
            sexualOrientation={sexualOrientation}
            handleSexualOrientationChange={handleSexualOrientationChange}
            sexualOrientationOther={sexualOrientationOther}
            handleSexualOrientationOther={handleSexualOrientationOther}
            clientSource={clientSource}
            handleClientSourceChange={handleClientSourceChange}
            personalEmail={personalEmail}
            handlePersonalEmailChange={handlePersonalEmailChange}
            phoneNumber={phoneNumber}
            handlePhoneNumberChange={handlePhoneNumberChange}
            livingWithOther={livingWithOther}
            handleLivingWithOther={handleLivingWithOther}
            passportNumber={passportNumber}
            handlePassportNumberChange={handlePassportNumberChange}
            visaExpirationDate={visaExpirationDate}
            handleVisaExpirationDateChange={handleVisaExpirationDateChange}
            currentAddress={currentAddress}
            handleCurrentAddressChange={handleCurrentAddressChange}
            city={city}
            handleCityChange={handleCityChange}
            province={province}
            handleProvinceChange={handleProvinceChange}
            country={country}
            handleCountryChange={handleCountryChange}
            nationality={nationality}
            handleNationalityChange={handleNationalityChange}
            rehabs={rehabs}
            rehabId={rehabId}
            handleRehabChange={handleRehabChange}
          />

          <div className="general-information-column">
            <TreatmentInformation
              roomNumber={roomNumber}
              handleRoomNumberChange={handleRoomNumberChange}
              clientIdState={clientIdState}
              clientStatus={props.clientStatus}
              firstName={firstName}
              lastName={lastName}
              profilePicture={profilePicture}
              selectedTherapist={selectedTherapist}
              handleSelectedTherapistChange={handleSelectedTherapistChange}
              assignedSupportWorker={assignedSupportWorker}
              handleAssignedSupportWorkerChange={
                handleAssignedSupportWorkerChange
              }
              therapistAppointmentDays={therapistAppointmentDays}
              handleTherapistAppointmentDaysChange={
                handleTherapistAppointmentDaysChange
              }
              therapistAppointmentTime={therapistAppointmentTime}
              handleTherapistAppointmentTimeChange={
                handleTherapistAppointmentTimeChange
              }
              supportWorkerAppointmentDays={supportWorkerAppointmentDays}
              handleSupportWorkerAppointmentDaysChange={
                handleSupportWorkerAppointmentDaysChange
              }
              supportWorkerAppointmentTime={supportWorkerAppointmentTime}
              handleSupportWorkerAppointmentTimeChange={
                handleSupportWorkerAppointmentTimeChange
              }
              stepsAppointmentDays={stepsAppointmentDays}
              handleStepsAppointmentDaysChange={
                handleStepsAppointmentDaysChange
              }
              stepsAppointmentTime={stepsAppointmentTime}
              handleStepsAppointmentTimeChange={
                handleStepsAppointmentTimeChange
              }
              generateTimeOptions={generateTimeOptions}
              medicalAppointment={medicalAppointment}
              handleMedicalAppointmentChange={handleMedicalAppointmentChange}
              visaAppointment={visaAppointment}
              handleVisaAppointmentChange={handleVisaAppointmentChange}
              massageDay={massageDay}
              handleMassageDayChange={handleMassageDayChange}
            />
            <AdmissionDischarge
              dateOfAdmission={dateOfAdmission}
              handleDateOfAdmissionChange={handleDateOfAdmissionChange}
              dischargeDate={dischargeDate}
              handleDischargeDateChange={handleDischargeDateChange}
              projectedResidentialDischargeDate={
                projectedResidentialDischargeDate
              }
              handleProjectedResidentialDischargeDateChange={
                handleProjectedResidentialDischargeDateChange
              }
              projectedProgramCompletionDate={projectedProgramCompletionDate}
              handleProjectedProgramCompletionDateChange={
                handleProjectedProgramCompletionDateChange
              }
            />
            <div className="general-information-upload-host">
              <UploaderGeneralInfosEncapsulatedBis {...props} />
            </div>
          </div>
        </div>
      </div>
      <EmergencyContact
        emergencyContactFirstName={emergencyContactFirstName}
        handleEmergencyContactFirstNameChange={
          handleEmergencyContactFirstNameChange
        }
        emergencyContactLastName={emergencyContactLastName}
        handleEmergencyContactLastNameChange={
          handleEmergencyContactLastNameChange
        }
        emergencyContactRelationship={emergencyContactRelationship}
        handleEmergencyContactRelationshipChange={
          handleEmergencyContactRelationshipChange
        }
        emergencyRelationshipOther={emergencyRelationshipOther}
        handleEmergencyRelationshipOther={handleEmergencyRelationshipOther}
        emergencyContactPhoneNumber={emergencyContactPhoneNumber}
        handleEmergencyContactPhoneNumberChange={
          handleEmergencyContactPhoneNumberChange
        }
        emergencyContactEmail={emergencyContactEmail}
        handleEmergencyContactEmailChange={handleEmergencyContactEmailChange}
        emergencyContactAddress={emergencyContactAddress}
        handleEmergencyContactAddressChange={
          handleEmergencyContactAddressChange
        }
        emergencyContactCity={emergencyContactCity}
        handleEmergencyContactCityChange={handleEmergencyContactCityChange}
        provinceEmergencyContact={provinceEmergencyContact}
        handleProvinceEmergencyContactChange={
          handleProvinceEmergencyContactChange
        }
        emergencyContactNationality={emergencyContactNationality}
        handleEmergencyContactNationalityChange={
          handleEmergencyContactNationalityChange
        }
        emergencyContactCountry={emergencyContactCountry}
        handleEmergencyContactCountryChange={
          handleEmergencyContactCountryChange
        }
        payerName={payerName}
        handlePayerNameChange={handlePayerNameChange}
        payerPhoneNumber={payerPhoneNumber}
        handlePayerPhoneNumberChange={handlePayerPhoneNumberChange}
      />

      <div className="button-container-form-gi">
        <Button
          variant="contained"
          onClick={() => updateClientData(props.clientId)}
          style={
            isModified && !isLoading
              ? {
                  backgroundColor: "red",
                  color: "white",
                  marginLeft: "15px",
                }
              : {
                  backgroundColor: "#1565C0",
                  color: "white",
                  marginLeft: "15px",
                }
          }
          disabled={isLoading}
          sx={{
            height: "40px",
            width: "220px",
            marginLeft: "25px",
            marginRight: "30px",
          }}
        >
          {isLoading
            ? "SAVING MODIFICATIONS..."
            : isModified
            ? "CLICK TO SAVE"
            : "SAVE MODIFICATIONS"}
        </Button>
      </div>
    </div>
  );
}

export default GeneralInformation;
